module.exports = __webpack_public_path__ + "static/media/NoBatchesjpg.80ac371c.jpg";